import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ToastContentProps } from 'react-toastify';
import palette from '@ui/palette';
import Typography from '@ui/Typography';
import Button from '@ui/Button';

export interface ToastProps {
  message: string;
  callToAction?: {
    label: string;
    onClick: () => void;
  };
}
// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const toastStyles = makeStyles({ name: 'CtaToast' })(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  message: {
    flexGrow: 2,
  },
  cta: {
    flexGrow: 1,
    color: palette.gray_100,
    background: palette.gray_700,
    border: 'none',
    cursor: 'pointer',
  },
}));

const CtaToast = (props: ToastContentProps<ToastProps>) => {
  const { data, closeToast } = props;
  const { classes } = toastStyles();

  return (
    <div className={classes.root}>
      <Typography variant="pMd" className={classes.message}>
        {data.message}
      </Typography>

      {data.callToAction && (
        <Button
          variant="secondary"
          aria-label={data.callToAction.label}
          onClick={() => {
            data.callToAction?.onClick();
            closeToast();
          }}
          size="small"
        >
          {data.callToAction.label}
        </Button>
      )}
    </div>
  );
};

export default CtaToast;
